import React, {PureComponent} from "react"
import {match as Match, Redirect} from "react-router-dom"

import {IndexRedirect, PartialRoute} from "@irati/utils/history/routing"
import authentication from "@irati/auth"
import devToggles from "@irati/dev-toggles"
import CompanyBenefitsSettings from "../components/Settings/CompanyBenefitsSettings"
import CompanyBenefitsList from "../components/Settings/CompanyBenefitsList"
import WelcomeEmail from "../components/Settings/WelcomeEmail/WelcomeEmail"
import PerksVisibility from "../components/Settings/PerksSettings/PerkVisibility"
import RecognitionSettings from "../components/Settings/RecognitionSettings/RecognitionSettings"
import CompanyBrand from "../containers/Settings/Brand"
import Celebrations from "../components/Settings/Occasions"
import CompanyValues from "../containers/Settings/CompanyValuesBasic"
import CustomRewards from "../containers/Settings/CustomRewards/CustomRewards"
import CustomRewardsForm from "../containers/Settings/CustomRewards/CustomRewardsForm"
import SelfSignUpSettings from "../components/Settings/CompanySignUpSettings/SelfSignUp/SelfSignUpSettings"
import SelfSignUp from "../containers/Settings/SignUpSettings/SelfSignUp"
import Integrations from "../containers/Settings/Integrations"
import ChecklistDirectorySync from "../components/Settings/Integration/DirectorySync/Checklist"
import ChecklistSSO from "../components/Settings/Integration/SSO/Checklist"
import CustomSSOName from "../components/Settings/Integration/SSO/CustomSSOName/index"
import SingleSignOn from "../components/Settings/Integration/SSO"
import HRISHomepage from "../components/Settings/Integration/DirectorySync/HRIS"
import {SETTINGS_LOGIN_SSU} from "./routeConfig"

interface Props {
  match: Match
}

class AdminSettings extends PureComponent<Props> {
  render() {
    const {match} = this.props
    const showSSOSettings = authentication.apps("admin.sso") && authentication.business().showSsoLogin
    const showDealVisibility = authentication.apps("admin.dealVisibility")
    const showPerks = authentication.apps("perks")

    return (
      <>
        <IndexRedirect match={match} to="/customisation/brand" />
        <PartialRoute
          match={match.url}
          exact
          path="/customisation"
          component={() => <Redirect to="/admin/settings/customisation/brand" />}
        />
        <PartialRoute component={CompanyBrand} exact match={match.url} path="/customisation/brand" title="Your brand" />
        <PartialRoute component={WelcomeEmail} exact match={match.url} path="/customisation/welcome-message" title="Welcome email" />
        {showPerks && (
          <>
            <PartialRoute
              component={CompanyBenefitsList}
              exact
              match={match.url}
              path="/customisation/benefits"
              title="Company benefits"
            />
            <PartialRoute
              component={CompanyBenefitsSettings}
              exact
              match={match.url}
              path="/customisation/benefits/settings"
              title="Company Benefits Settings"
            />
            {showDealVisibility && (
              <PartialRoute
                component={PerksVisibility}
                exact
                match={match.url}
                path="/customisation/perk-visibility"
                title="Perks settings"
              />
            )}
          </>
        )}
        <PartialRoute
          component={RecognitionSettings}
          exact
          match={match.url}
          path="/roles-and-permissions/recognition"
          title="Recognition Permissions"
        />
        <PartialRoute component={Celebrations} exact match={match.url} path="/customisation/celebrations" title="Company celebrations" />
        <PartialRoute match={match.url} exact path="/customisation/values" component={CompanyValues} title="Company values" />
        {devToggles.showCustomReward() && (
          <>
            <PartialRoute component={CustomRewards} exact match={match.url} path="/customisation/custom-reward" title="Custom reward" />
            <PartialRoute
              component={CustomRewardsForm}
              exact
              match={match.url}
              path="/customisation/custom-reward/create"
              title="Create custom reward"
            />
            <PartialRoute
              component={CustomRewardsForm}
              exact
              match={match.url}
              path="/customisation/custom-reward/edit/:uuid"
              title="Edit custom reward"
            />
          </>
        )}
        <PartialRoute
          component={() => <SelfSignUp showBackIcon={false} backLink={SETTINGS_LOGIN_SSU} />}
          exact
          match={match.url}
          path="/login/ssu"
          title="Self set up"
        />
        {showSSOSettings && (
          <PartialRoute component={SelfSignUpSettings} exact match={match.url} path="/login/sso" title="Single sign on" />
        )}
        <PartialRoute component={Integrations} exact match={match.url} path="/login/integration" title="Integration" />
        <PartialRoute component={SingleSignOn} exact match={match.url} path="/login/integration/sso" title="Integration SSO" />
        <PartialRoute component={HRISHomepage} exact match={match.url} path="/login/integration/dsync" title="Integration DSYNC" />
        <PartialRoute
          component={ChecklistSSO}
          exact
          match={match.url}
          path="/login/integration/sso/checklist"
          title="Integration SSO Checklist"
        />
        <PartialRoute component={CustomSSOName} exact match={match.url} path="/login/integration/sso/custom" title="Custom SSO Name" />
        <PartialRoute
          component={ChecklistDirectorySync}
          exact
          match={match.url}
          path="/login/integration/dsync/checklist"
          title="Integration DSYNC Checklist"
        />
      </>
    )
  }
}

export default AdminSettings
